export default __webpack_public_path__ + "static/4-c1beecaae8f82308729713f0d442c777.png";